import { useState } from 'react'

import { getAPIClient } from 'api/axios'

import { Coupon } from '../types/coupon'
import { couponErrorMessage } from './couponErrorMessage'

interface UseReactivateCouponReturn {
  reactivateCoupon: (uuid: string) => Promise<Coupon | null>
  loading: boolean
  error: string | null
}

export const useReactivateCoupon = (): UseReactivateCouponReturn => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const client = getAPIClient()

  const reactivateCoupon = async (uuid: string): Promise<Coupon | null> => {
    setLoading(true)
    setError(null)

    try {
      const response = await client.post(`/v1/coupons/${uuid}/reactivate`)
      return response.data.record ?? response.data.coupon
    } catch (err: any) {
      const message = couponErrorMessage(err, 'Erro ao reativar cupom')
      setError(message)
      throw message
    } finally {
      setLoading(false)
    }
  }

  return { reactivateCoupon, loading, error }
}
